document.addEventListener('DOMContentLoaded', function () {
  function initMenuToggles() {
    var toggles = document.querySelectorAll('.main-nav__toggle');
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var li = btn.closest('li');
        if (!li) return;
        li.classList.toggle('open');
        var expanded = li.classList.contains('open');
        // update aria-expanded on the nearest link toggleable
        var link = li.querySelector('a[aria-haspopup="true"]');
        if (link) link.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        // update button aria too
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });
    // close all submenus on escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.main-nav__item.open, .main-nav__subitem.open').forEach(function (el) {
          el.classList.remove('open');
        });
      }
    });
  }

  initMenuToggles();

  // re-init on resize if necessary
  var resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      // (optional) close mobile menus on desktop width
      if (window.innerWidth >= 992) {
        document.querySelectorAll('.main-nav__item.open').forEach(function (el) { el.classList.remove('open'); });
      }
    }, 150);
  });
});
